import ResizeAndDragabble from "components/ResizeAndDraggable";
import DemoPreview from "components/ViewDemoModal";
import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import { WriteEditWhite } from "utils/assets/images";
import COLOR from "utils/constants/color";
import {Cancel} from '@mui/icons-material';
import AccordinButton from "components/AccordinButton";
import NewWheelComponent from "components/NewWheel";
import Loading from "components/Loading";
import * as Sentry from '@sentry/react';
import SentryWrap from 'components/Sentry';

const WidgetWheelComponent = (props) => {
  const { result, isTeacher, selectedUser, segColors, loader } =
    props?.states || null;
  const { onClose, handleOpenEditModal, onFinished } = props?.funcObj || null;
  const [dimensions, setDimensions] = useState({});
  const [showAccordin, setShowAccordin] = useState(true);
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleResize = () => {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };

  const handleTouch = (event) => {
    event.preventDefault();
    onClose();
  };

  const getSegments = useCallback(() => {
    try {
      if (Array.isArray(selectedUser) && selectedUser.length > 0) {
        const segmentData = selectedUser.map((k, i) => ({
          color: segColors[i] || segColors[i % segColors.length] || "#000000", // Fallback color
          label: k?.userName || "Unknown",
        }));
        return segmentData;
      }
      return [];
    } catch (error) {
      console.error("Error in getSegments:", error);
      Sentry.captureException(`402 Error in getSegments: ${error}`);
      return [];
    }
  }, [selectedUser, segColors]);

  return (
    <SentryWrap>
      <Container className="allCheckListSEction wigetsContainer">
      <div className="mainCheckList">
        <ResizeAndDragabble
          defaultValue={{
            x: 150,
            y: 100,
            width: windowSize?.width >= 768 ? 501 : 270,
            height: windowSize?.width >= 768 ? 600 : 323,
          }}
          // minWidth={430}
          minHeight={!showAccordin ? null : 323}
          showAccordin={showAccordin}
          resize={(data) => setDimensions(data)}
          resizeEnd={(data) => setDimensions(data)}
          page={"wheel"}
        >
          <div
            className="checkListTopSection addWidgetSpc"
            style={{
              position: "relative",
              boxShadow: "rgba(0, 0, 0, 0.2) 0px 2px 4px",
              height: showAccordin ? "100%" : "0px",
              width: "100%",
              display: "grid",
              placeItems: "center",
              padding: "0px",
            }}
          >
            <Cancel
              onClick={() => onClose()}
              onTouchStart={handleTouch}
              style={{
                zIndex: 1,
                marginLeft: "5px",
                position: "absolute",
                right: 11,
                top: 14,
                fontSize: 20,
                color: "red",
                background: "white",
                borderRadius: 20,
                cursor: "pointer",
              }}
            />
            <div
              className={`checkListFirstTxt widgetFooterGradientOrange absolute top-0 w-full bg-blue-10 pt-17px pb-14px ${
                showAccordin ? "br-topLeft-topRight-20px" : "br-12px"
              } `}
            >
              <AccordinButton
                open={showAccordin}
                onClose={() => setShowAccordin((prev) => !prev)}
              />
              <span className="text-white text-ft12-700">Wheel</span>
            </div>
            {showAccordin && (
              <>
                {loader ? (
                  <Loading size={30} />
                ) : (
                  <>
                    <div className="mt-49px">
                      {selectedUser?.length > 0 && (
                        <NewWheelComponent
                          dimensions={dimensions}
                          segments={getSegments()}
                          onFinished={onFinished}
                          newStudentList={selectedUser} // user list
                        />
                      )}
                    </div>
                    <div className="widget-wheel-text">{result}</div>
                    {isTeacher && loader === false && (
                      <div className={"add-preview-wheel"}>
                        <EditListOption
                          onClick={() => {
                            handleOpenEditModal(true);  
                          }}
                          onTouchStart={(event) => {
                            event.preventDefault();
                            handleOpenEditModal(true);
                          }}
                        >
                          Edit <IconsImg src={WriteEditWhite} />
                        </EditListOption>
                        <DemoPreview
                          video_id={"1way-wheel-demo"}
                          wrapperStyle={{
                            justifyContent: "flex-end",
                            marginLeft: "5px",
                          }}
                        />
                      </div>
                    )}
                  </>
                )}
              </>
            )}
            {showAccordin && (
              <div className="widgetFooter widgetFooterGradientOrange"><label>Widget</label></div>
            )}
          </div>
        </ResizeAndDragabble>
      </div>
      </Container>
    </SentryWrap>
  );
};

export default React.memo(WidgetWheelComponent);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  // min-height: 500px;
  // background-color: rgb(58, 58, 58);
  position: relative;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 0px;
  z-index: 99999999;
  position: fixed;
  cursor: grab;
  top: 0;
  // left: 25%;
  //   margin: 15px auto;/
  transform: translate(31%, 0%);

  @media (max-width: 1450px) {
    // width: 96%;
    transform: translate(0%, 0%);
  }
  @media (max-width: 992px) {
    // width: 95%;
    transform: translate(0%, 0%);
  }
`;
const EditListOption = styled.div`
  text-align: center;
  align-items: center;
  background-image: linear-gradient(
    90deg,
    ${COLOR.WheelEditColor1} 0%,
    ${COLOR.WheelEditColor2} 40%,
    ${COLOR.WheelEditColor3} 100%
  );
  color: #fff;
  display: flex;
  transition: all 300ms ease;
  white-space: nowrap;
  width: 100px;
  height: 30px;
  border-radius: 10px;
  justify-content: center;
  font-weight: bolder;
  cursor: pointer;
`;
const IconsImg = styled.img`
  height: 15px;
  width: 15px;
  object-fit: cover;
  margin-left: 10px;
`;
